import CentrosList from './List.jsx';

export default function CentrosPage() {
  return <CentrosList />;
}
